import { requiresKyc } from "@nh/shared";
import type { NavMap } from "@/shared/ui/layout";

/**
 * El menú sin la entrada de KYC para quien no sube documentos
 * (Estados Unidos, Anahí 22-oct-2026). Se quita por la ruta, que
 * termina en `/kyc` en los dos paneles.
 */
export function navForCountry(nav: NavMap, country: string | null | undefined): NavMap {
  if (requiresKyc(country)) return nav;
  return nav.map((section) => ({
    ...section,
    items: section.items.filter((item) => !item.to.endsWith("/kyc")),
  }));
}
